export default __webpack_public_path__ + "guide--raster-rasters-are-pixels-960-6f7ecae039b14ec348df210215bd42ff.webp";